var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpTriangleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18077 6.17033C9.57887 5.60162 10.4211 5.60162 10.8192 6.17033L15.8986 13.4265C16.3625 14.0893 15.8884 15 15.0793 15L4.92065 15C4.11163 15 3.63748 14.0893 4.10142 13.4265L9.18077 6.17033Z",
    fill: "#F23131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTriangleRed);
export default __webpack_public_path__ + "static/media/up_triangle_red.30c28139f79d441037b6979be7df41f1.svg";
export { ForwardRef as ReactComponent };